export const authReducer = (state, action) => {
  switch (action.type) {
    case "addError":
      return {
        ...state,
        user: null,
        status: "not-authenticated",
        token: null,
        errorMessage: action.payload,
      };

    case "removeError":
      return {
        ...state,
        errorMessage: "",
      };
    case "signIn":
      return {
        ...state,
        errorMessage: "",
        status: "authenticated",
        token: action.payload.token,
        user: action.payload.data,
      };
    case "logout":
    case "notAuthenticated":
      return {
        ...state,
        status: "not-authenticated",
        token: null,
        user: null,
      };

    default:
      return state;
  }
};
